import { useMutation, useQueryClient } from "@tanstack/react-query";

import { directApplySyncQueryKeys } from "./query-keys";

import { instance } from "@/lib/axios/instance";

export interface ResyncQueuedResult {
  queued: boolean;
  from: string;
  to: string;
}

export function useTriggerResync(
  integrationName: string | undefined,
  clientId: string | undefined,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ from, to }: { from: string; to: string }) => {
      if (!clientId || !integrationName) {
        throw new Error("ClientId and integrationName are required");
      }

      const { data } = await instance.post<ResyncQueuedResult>(
        `/api/v2/Integrations/${integrationName}/direct-apply/sync/resync`,
        { from, to },
        { params: { clientId } },
      );

      return data;
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: directApplySyncQueryKeys.all,
      });
    },
  });
}
